export default {"src":"/_next/static/media/feature-2.4df059ed.svg","height":175,"width":272};